import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { Space, Title } from '@mantine/core'
import { Alert, Anchor } from '@/components/Elements'
import { AuthCard } from '@/features/auth/components/Elements'
import { useResetPasswordMutation } from '@/features/auth/store'
import { useQuery } from '@/hooks'
import { FormValues, ResetPasswordForm } from './ResetPasswordForm'

type SubmitParams = FormValues & {
  token: string
  email: string
}

export const ResetPasswordContainer = () => {
  const { t } = useTranslation()

  const query = useQuery()
  const { token } = useParams()

  const [resetPassword] = useResetPasswordMutation()

  const [success, setSuccess] = useState<string | null>(null)

  const handleSubmit = async (values: FormValues) => {
    setSuccess(null)

    const params: SubmitParams = {
      ...values,
      token: token || '',
      email: query.get('email') || '',
    }

    const { message } = await resetPassword(params).unwrap()

    setSuccess(message || t('success'))
  }

  return (
    <AuthCard title={t('reset_password')}>
      {success && (
        <Alert type={'success'} mb={'sm'}>
          {success}
        </Alert>
      )}

      <ResetPasswordForm onSubmit={handleSubmit} />

      <Space h={'lg'} />

      <div className={'mt-4 flex'}>
        <Title order={6}>
          {t('back_to')}{' '}
          <Anchor component={Link} to={'/login'}>
            {t('login')}
          </Anchor>
        </Title>
      </div>
    </AuthCard>
  )
}
